import React from 'react';
import classNames from 'classnames';

import './styles.css';

const DHeader = ({children}) => (
  <div className="DetailsContent__Navigation colab-centered-v">{children}</div>
);

const DLeftSideBar = ({children}) => (
  <div className="DetailsContent__leftSideBar">{children}</div>
);

const DContent = ({children}) => (
  <div className="DetailsContent__content">{children}</div>
);

class DetailsContent extends React.Component<{className?: string}> {
  static Header = DHeader;
  static LeftSideBar = DLeftSideBar;
  static Content = DContent;

  render() {
    const {className} = this.props;

    return (
      <div className={classNames('DetailsContent', className)}>
        {this.props.children}
      </div>
    );
  }
}

export default DetailsContent;
